import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class CommonpropertiesService {

  systemName: string;
  radioCheck: boolean;
  htmlString: string;
  tableFlag: boolean;
  queryGrid: boolean;
  dynamicElements: boolean;
  gridFlag: boolean;
  quickFlag: boolean;
  gridId: string;
  pleaseSelect: boolean;
  drawerFlag: boolean;
  drawerCnt: number = 0;
  toggle_data: boolean;
  overlayFlag: boolean;
  headerFlag: boolean;
  worklistIcon: boolean;
  complexListId: boolean;
  complexDivListId: boolean;
  complexListVarId: string;
  panelComplexId: string;
  listPanelHeader: boolean;

  tableListVarId: string;
  tableListVarCount: number = 0;
  listVarCount: number = -1;
  drawerCategory: string;
  tabsFlag: boolean;
  menuFlag: boolean;
  overflowTabsFlag: boolean;
  fileAttachmentListFlag: boolean;
  overflowWorklistsFlag: boolean;
  accordionFlag: boolean;
  dateFlag: boolean;
  sliderFlag: boolean;
  tableHeads: string;
  columnList: string;
  columnSort: boolean;
  columnSearch: boolean;
  complexElementBeanClass: string;  // use this for all element 
  outputModelName: string;  // only for table
  simpleElementBeanClass: string;  // use this for all element
  lay_obj = {};
  globalBreadcrumbMethod: string;
  globalCountT: number = 0;
  section_count: number = 0;
  cnt_toggle: number = 0;
  bulkClass: string;
  bulkParentClass: string;
  userGlobalTimezone: string;
  userGlobalTimezoneOffSet: string ="-6";
  globalDateFormat: string = "MM/DD/YYYY hh:mm tt";

  layoutObject1: string;
  layoutObject2: string;
  layoutObject3: string;
  layoutObject4: string;
  layoutObject5: string;
  gloabalObject: string;
  setDefaultDash: boolean;
  islistVarIdOpen: boolean;
  isCourousalOpen: boolean;
  courousalCount = -1;
  isPagination: boolean;
  showMore: boolean;
  noOfRows: number = 0;
  rowNum: number = 0;
  totalCharCount: string;
  complexElementId: string;
  maxRepeatCount: number = -1;
  selectData = "";
  activeTab = "";
  activePages = "";

  //Pacific/Auckland
  timeZones = [{
    timeZoneCode: 'NZDT',
    offSetUTC: '+12',
    UTCTime: '1',
    timeZoneName: 'Pacific/Auckland'
  }, {
    timeZoneCode: 'GMT',
    offSetUTC: '+1',
    UTCTime: '1',
    timeZoneName: 'Europe/London'
  }, {
    timeZoneCode: 'ACDT',
    offSetUTC: '+10.5',
    UTCTime: '1',
    timeZoneName: 'Australia/Adelaide'
  },
  {
    timeZoneCode: 'CET',
    offSetUTC: '+1',
    UTCTime: '1',
    timeZoneName: 'Europe/Zurich'
  }, {
    timeZoneCode: 'EST',
    offSetUTC: '-5',
    UTCTime: '6',
    timeZoneName: 'America/New_York'
  }, {
    timeZoneCode: 'CST',
    offSetUTC: '-6',
    UTCTime: '7',
    timeZoneName: 'America/Chicago'
  }, {
    timeZoneCode: 'MST',
    offSetUTC: '-7',
    UTCTime: '8',
    timeZoneName: 'America/Boise'
  }, {
    timeZoneCode: 'PST',
    offSetUTC: '-8',
    UTCTime: '9',
    timeZoneName: 'America/Los_Angeles'
  }, {
    timeZoneCode: 'JCST',
    offSetUTC: '+9',
    UTCTime: '9',
    timeZoneName: 'Asia/Tokyo'
  }, {
    timeZoneCode: 'JST',
    offSetUTC: '+9',
    UTCTime: '9',
    timeZoneName: 'Asia/Tokyo'
  }, {
    timeZoneCode: 'JDT',
    offSetUTC: '+9',
    UTCTime: '9',
    timeZoneName: 'Asia/Tokyo'
  }, {
    timeZoneCode: 'HMT',
    offSetUTC: '-6',
    UTCTime: '7',
    timeZoneName: 'Asia/Kolkata'
  }, {
    timeZoneCode: 'BURT',
    offSetUTC: '-6',
    UTCTime: '7',
    timeZoneName: 'Asia/Kolkata'
  }, {
    timeZoneCode: 'IST',
    offSetUTC: '-6',
    UTCTime: '7',
    timeZoneName: 'Asia/Kolkata'
  }];

  arrDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  arrMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];


  complexElementBeanId: string;
  lastScrollLeft: number = 0; // stores left scroll position for horizontal scroll 
  toggleLog: boolean;

  selectedCount: string;
  defaultCount: string;
  worklist : any = {};
  //sessionId = $("#mqSess").val();
  isMultiRowExpand: boolean;
  affectedTblArray = [];

  constructor() { }
}
